import { defineClientModule } from '@/app/module';

/**
 * cards. PlayerCard SVG with the full body figure slot, backdrops, reveal, PNG export, avatars.
 * See docs/MODULE-GUIDE-client.md. Keep this file light: data and lazy imports only.
 */
export default defineClientModule({
  name: 'cards',
});
